<ng-container *transloco="let t">
  <div class="header" (click)="onHeadingClick()" [class.full-screen]="isFullScreen" [class.dark-mode]="darkMode"
       [style.--hr-progress-fill]="(finished / started * 100) + '%'">


    <div class="mobile-action-top mb-1">
      <ng-template [ngTemplateOutlet]="actionButtons"></ng-template>
    </div>

    <div class="d-flex justify-content-start align-items-center">

      <ng-template [ngTemplateOutlet]="raceLogoLeft"></ng-template>

      <div class="d-flex justify-content-between flex-column w-100 ps-2"
           [class.flex-lg-row]="!isFullScreen">
        <div>
          <div [class.d-none]="isFullScreen"
               [class.d-block]="!isFullScreen"
               [class.d-lg-none]="!isFullScreen">
            <ng-container *ngTemplateOutlet="statusTag"></ng-container>
          </div>

          @if (type === LiveResultHeadingType.RACE) {
            <p class="info">
              <ng-container *ngTemplateOutlet="eventName"></ng-container>
            </p>
          }

          <p class="title fw-500">
            @if (type === LiveResultHeadingType.RACE) {
              <ng-container *ngTemplateOutlet="raceName"></ng-container>
            } @else if (type === LiveResultHeadingType.EVENT) {
              <ng-container *ngTemplateOutlet="eventName"></ng-container>
            }
          </p>

          <div class="d-flex w-100 info"
               [class.flex-row]="isFullScreen"
               [class.align-items-center]="isFullScreen"
               [class.justify-content-start]="isFullScreen"
               [class.flex-column]="!isFullScreen"
               [class.flex-lg-row]="!isFullScreen"
               [class.align-items-start]="!isFullScreen"
               [class.align-items-lg-center]="!isFullScreen"
               [class.justify-content-lg-between]="!isFullScreen">

            <ng-template [ngTemplateOutlet]="raceInfo"></ng-template>

            <ng-template [ngTemplateOutlet]="participantCount"></ng-template>

          </div>
        </div>
      </div>

      <div></div>

      <ng-template [ngTemplateOutlet]="raceLogoRight"></ng-template>

      <div class="mobile-action-right">
        <ng-template [ngTemplateOutlet]="actionButtons"></ng-template>
      </div>
    </div>
  </div>

  <ng-template #participantCount>
    @if (type === LiveResultHeadingType.RACE && !isFullScreen) {
      <div class="d-flex align-items-center pe-3">
        <p>{{ t("event.item.participants") }}: <span class="fw-medium ps-1">{{ started ?? "-" }}</span></p>
      </div>
      @if (finished && finished > 0) {
        <div class="d-flex align-items-center pe-2">
          <p>{{ t("app.common.finished") }}: <span class="fw-medium ps-1">{{ finished }}</span></p>
        </div>
      }
    }
  </ng-template>

  <ng-template #raceInfo>
    <div class="d-flex flex-column flex-md-row">
      <div class="pe-3">
        <ng-container *ngTemplateOutlet="sportBadgeTemplate"></ng-container>
      </div>

      <div class="d-flex align-items-center pe-3">
        <div class="d-flex pe-1">
          <img src="assets/icons/icons-alt/calendar-04.svg" alt="Start time" class="calendar-icon"/>
        </div>
        <p>{{ dateString }}</p>
      </div>

      @if (type === LiveResultHeadingType.EVENT && (event?.city || country)) {
        <div class="d-flex align-items-center pe-3">
          <div class="d-flex pe-1">
            <img src="assets/icons/icons-alt/location-alt.svg" alt="loc" class="calendar-icon"/>
          </div>
          <app-location-display [city]="event?.city" [countryId]="event?.country" [showIcon]="false"/>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #raceLogoLeft>
    <div [class.d-block]="isFullScreen"
         [class.d-none]="!isFullScreen"
         [class.d-lg-block]="!isFullScreen">
      <app-live-race-image-loader
        [src]="race?.imageIcon || event?.imageIcon || 'assets/img/bg3.jpg'"
        [isFullScreen]="isFullScreen"
        [displayLoader]="status === LiveItemStatus.IN_PROGRESS"/>
    </div>
  </ng-template>

  <ng-template #raceLogoRight>
    <div [class.d-block]="!isFullScreen"
         [class.d-lg-none]="!isFullScreen"
         [class.d-none]="isFullScreen">
      <app-live-race-image-loader
        [src]="race?.imageIcon || event?.imageIcon || 'assets/img/bg3.jpg'"
        [isFullScreen]="isFullScreen"
        [displayLoader]="status === LiveItemStatus.IN_PROGRESS"/>
    </div>
  </ng-template>

  <ng-template #actionButtons>
    <div [class.d-block]="isFullScreen"
         [class.d-none]="!isFullScreen"
         [class.d-lg-block]="!isFullScreen">
      @if (isFullScreen) {
        <div class="header-right">
          <div class="d-flex align-items-center">
          <div class="live-stats pr-20">
            <div class="d-flex align-items-end">
              <span class="finisher-count">{{ finished }}</span>
            </div>
            <div class="live-meta">
              <div class="live-badge">
                <div class="pulse-dot" aria-hidden="true"></div>
                <span class="live-label">{{ t("live.results.race.header.title") }}</span>
              </div>
              <span class="finisher-total">/ {{ started }} {{ t("app.common.finished") | lowercase }}</span>
            </div>
          </div>
          <div class="divider" aria-hidden="true"></div>
          <div class="d-flex justify-content-center align-items-center gap-2 ms-3 pr-20">
            <button class="btn btn-link p-0 dark-mode-toggle" (click)="toggleDarkMode()">
              <i [class]="darkMode ? 'bi bi-sun-fill' : 'bi bi-moon-fill'"></i>
            </button>
            <button class="btn btn-link p-0 dark-mode-toggle" (click)="toggleSplitScreen()">
              <i [class]="isSplitScreen ? 'bi bi-square' : 'bi bi-layout-split'"></i>
            </button>
            <button class="btn btn-link p-0 dark-mode-toggle" (click)="toggleRanking()">
              <i [class]="showRanking ? 'bi bi-list-ol' : 'bi bi-list-ol'"></i>
            </button>
            <button class="btn btn-link p-1 dark-mode-toggle" (click)="openPhotoPointPage()">
              <i class="bi bi-camera"></i>
            </button>
          </div>
          <div class="divider" aria-hidden="true"></div>
        </div>
          <div>
            <img src="assets/icons/tracey-alt-logo.svg" alt="Tracey logo" class="tracey-icon tracey-logo-full cursor-pointer" (click)="goToLiveResults()"/>
            <img src="assets/icons/tracey-alt-logo-small.svg" alt="Tracey logo" class="tracey-icon tracey-logo-small cursor-pointer" (click)="goToLiveResults()"/>
          </div>

        </div>
      } @else {
        <ng-container *ngTemplateOutlet="statusTag"></ng-container>
      }
    </div>
  </ng-template>

  <ng-template #sportBadgeTemplate>
    <ng-container *ngIf="type === LiveResultHeadingType.RACE && race?.sport; else eventSport">
      <p class="text-uppercase">{{ t("app.common.sports." + race!.sport) }}</p>
    </ng-container>
    <ng-template #eventSport>
      <ng-container *ngIf="type === LiveResultHeadingType.EVENT && event?.sportOne">
        <p class="text-uppercase">{{ t("app.common.sports." + event!.sportOne) }}</p>
      </ng-container>
    </ng-template>
  </ng-template>

  <ng-template #statusTag>
    <div class="tag"
         [class.dark-gray]="status === LiveItemStatus.FINISHED"
         [class.amber]="status === LiveItemStatus.TO_BE_STARTED"
         [class.green]="status === LiveItemStatus.IN_PROGRESS">
      <span class="text-uppercase">{{ t("live.results.status." + status) }}</span>
    </div>
  </ng-template>

  <ng-template #eventName>
    @if (event) {
    <app-language-output
      [hrLabel]="event.name" [srLabel]="event.nameSr" [enLabel]="event.nameEng"
      [itLabel]="event.nameIta" [bsLabel]="event.nameBs" [siLabel]="event.nameSlo"
      [defaultLanguage]="event.defaultLanguage" [languages]="languages"/>
    }
  </ng-template>

  <ng-template #raceName>
    @if (race) {
    <app-language-output
      [hrLabel]="race.name" [enLabel]="race.nameEng" [srLabel]="race.nameSr"
      [itLabel]="race.nameIta" [siLabel]="race.nameSlo" [bsLabel]="race.nameBs"
      [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
    }
  </ng-template>

</ng-container>
